import { NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { RegistrationRouteReuseStrategy } from './components/registrations/registration-route-reuse-strategy';
import { NotFoundComponent } from './components/common/not-found/not-found.component';
import { AuthCallbackComponent } from './components/common/auth-callback/auth-callback.component';

// routes
const appRoutes: Routes = [
	{
		path: '',
		redirectTo: 'dashboard',
		pathMatch: 'full'
	},
	{
		// MSAL redirects back here after Azure AD login — handles the auth response,
		// then navigates to the default route (see AuthCallbackComponent).
		path: 'auth-callback',
		component: AuthCallbackComponent
	},
	{
		path: 'dashboard',
		canActivate: [MsalGuard],
		loadComponent: () =>
			import('./components/dashboard/page/dashboard-page.component').then((m) => m.DashboardPageComponent)
	},
	{
		path: 'acquisitions',
		canActivate: [MsalGuard],
		loadChildren: () => import('./components/acquisitions/acquisition.module').then((m) => m.AcquisitionModule)
	},
	{
		path: 'renewal',
		canActivate: [MsalGuard],
		loadChildren: () => import('./components/renewals/renewals.module').then((m) => m.RenewalsModule)
	},
	{
		path: 'monitoring',
		canActivate: [MsalGuard],
		loadChildren: () => import('./components/monitoring/monitoring.module').then((m) => m.MonitoringModule)
	},
	{
		path: 'caches',
		canActivate: [MsalGuard],
		loadChildren: () => import('./components/caches/caches.module').then((m) => m.CachesModule)
	},
	{
		path: 'registrations',
		canActivate: [MsalGuard],
		loadChildren: () => import('./components/registrations/registrations.module').then((m) => m.RegistrationsModule)
	},
	{
		path: 'move',
		canActivate: [MsalGuard],
		loadChildren: () => import('./components/move/move.module').then((m) => m.MoveModule)
	},
	{
		path: 'simulation',
		canActivate: [MsalGuard],
		loadChildren: () => import('./components/simulation/simulation.module').then((m) => m.SimulationModule)
	},
	{
		path: 'product-services',
		canActivate: [MsalGuard],
		loadChildren: () =>
			import('./components/product-services/product-services.module').then((m) => m.ProductServicesModule)
	},
	{
		path: 'documents-template-manager',
		canActivate: [MsalGuard],
		loadChildren: () =>
			import('./components/documents-template-manager/documents-template-manager.module').then(
				(m) => m.DocumentsTemplateManagerModule
			)
	},
	{
		path: 'not-found',
		component: NotFoundComponent
	},
	{
		path: '**',
		component: NotFoundComponent
	}
];

@NgModule({
	imports: [RouterModule.forRoot(appRoutes, { onSameUrlNavigation: 'reload' })],
	exports: [RouterModule],
	providers: [
		{
			provide: RouteReuseStrategy,
			useClass: RegistrationRouteReuseStrategy
		}
	]
})
export class AppRoutingModule {}
